const optionsRadius = [
   // { value: 100, label: '100 mètres', imperial: 115, zoomNoMobile: 18, zoomMobile: 17},
   // { value: 250, label: '250 mètres', imperial: 280, zoomNoMobile: 17, zoomMobile: 16},
    { value: 500, label: '500 mètres', imperial: 550, zoomNoMobile: 16, zoomMobile: 15},
    { value: 1000, label: '1 kilomètre', imperial: 1100, zoomNoMobile: 15, zoomMobile: 14},
    { value: 2000, label: '2 kilomètres', imperial: 2200, zoomNoMobile: 14, zoomMobile: 13},
    //{ value: 5000, label: '5 kilomètres', imperial: 5500, zoomNoMobile: 13, zoomMobile: 11},
];

export default optionsRadius;